import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { usePathname } from 'src/routes/hooks';
import Header from 'src/layouts/main/header'; // Adjust the path if needed


export default function UnsubscribeLayout({ children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
      <Box
        component="img"
        // src={isNavMini ? '/assets/MeruDeskShort.png' : '/assets/MeruDesk.png'}
        src="/assets/MeruDesk.png"
        sx={{
          width: 160,
          height: 'auto',
          cursor: 'pointer',
          display: 'inline-flex',
          marginTop: '25px',
          marginLeft: '25px',
        }}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: { xs: 8, md: 10 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

UnsubscribeLayout.propTypes = {
  children: PropTypes.node,
};
